// Decouples the generated API client from Firebase. The AuthProvider registers
// a getter here on load; `api.ts` calls `getIdToken()` in its request
// interceptor without ever importing `firebase/auth`. Keeps the dependency
// direction clean: api → auth-token ← AuthProvider → firebase.

type IdTokenGetter = () => Promise<string | null>;

let getter: IdTokenGetter = () => Promise.resolve(null);

export function setIdTokenGetter(fn: IdTokenGetter): void {
  getter = fn;
}

export function getIdToken(): Promise<string | null> {
  return getter();
}
